import { ginzaxiaomaApiRequest } from 'apis';

const omsRecycleOrderDraftApi = {
  create(dto: { storeId: number; data: Record<string, any>; title: string }) {
    return ginzaxiaomaApiRequest.post(
      '/admin/oms-recycle-order-draft/create',
      dto
    );
  },
  getList(storeId?: number) {
    return ginzaxiaomaApiRequest.post<
      {
        id: number;
        storeId: number;
        title: string;
        data: Record<string, any>;
        createdAt: string;
      }[]
    >('/admin/oms-recycle-order-draft/list', {
      storeId,
    });
  },
  delete(id: number) {
    return ginzaxiaomaApiRequest.delete(`/admin/oms-recycle-order-draft/${id}`);
  },
};

export default omsRecycleOrderDraftApi;
